export default "__VITE_ASSET__DB0vXGx7__"